import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/arrow-right.png';
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
import { computed } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GuideSectionButton',
    props: {
        section: {}
    },
    setup(__props) {
        const router = useRouter();
        const props = __props;
        const completedTaskCount = computed(() => {
            return props.section.tasks.filter((t) => t.completed).length;
        });
        const allTasksCompleted = computed(() => {
            return completedTaskCount.value === props.section.tasks.length;
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", {
                class: "guide-tasks-section-button",
                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/Guides/Sections/' + _ctx.section.id)))
            }, [
                _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    class: "icon",
                                    src: _ctx.section.icon ?? require('@/assets/round1.png')
                                }, null, 8, _hoisted_1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-0" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "title-col" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.section.title), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-0" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "v-col-1 dot-col" }, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    src: allTasksCompleted.value ? require('@/assets/green-dot.png') : require('@/assets/orange-dot.png')
                                }, null, 8, _hoisted_2)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_col, { class: "v-col-7 tasks-col" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(completedTaskCount.value) + "/" + _toDisplayString(_ctx.section.tasks.length) + " tasks ", 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_col, { class: "arrow-col" }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createElementVNode("img", {
                                    class: "arrow",
                                    src: _imports_0
                                }, null, -1)
                            ])),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
